export function getAllFieldNamesRecursive(schema) {
    const names = [];
    const traverse = (obj) => {
      if (!obj) return;
      if (Array.isArray(obj)) {
        obj.forEach(traverse);
      } else if (typeof obj === "object") {
        if (obj.name) names.push(obj.name);
        Object.values(obj).forEach(traverse);
      }
    };
    traverse(schema);
    return [...new Set(names)];
  }
  
  export function getAllNamesFromMultipleSchemas(schemas) {
    let allNames = [];
    schemas.forEach((schema) => {
      allNames = [...allNames, ...getAllFieldNamesRecursive(schema)];
    });
    return [...new Set(allNames)];
  }
  